import styled from 'styled-components';

const RemoveCloseButton = styled.div`
  .Select-clear-zone {
    display: none;
  }
`;
const QuickReply = styled.span`
  display: flex;

  flex-wrap: wrap;
  margin-top: 3px;
  gap: 3px;
  .quick-reply-container {
    font-family: Helvetica;
    color: rgb(38, 156, 254);
    font-size: 14px;
    font-weight: 600;
    height: 34px;
    line-height: 20px;
    padding: 0px 16px;
    white-space: pre-wrap;
    display: flex;
    -webkit-box-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    align-items: center;
    background-color: rgb(255, 255, 255);
    border-radius: 7px;
    box-sizing: border-box;
    -webkit-box-flex: 1;
    flex-grow: 1;
    min-width: calc(50% - 2px);
  }
`;
const PreviewMessage = styled.div`
  font-family: Helvetica;
  background-color: rgb(255, 255, 255);
  border-radius: 0px 10px 10px;
  margin-top: 1px;
  min-height: 50px;
  position: relative;
  overflow-wrap: break-word;
  padding: 10px;
  .header-text {
    font-size: 15px;
    font-weight: bold;
    line-height: 19px;
    margin-bottom: 15px;
  }
  .header-image {
    background: gainsboro;
    display: block;
    margin: auto;
    padding: 25px 100px;
    border-radius: 12px;
    margin-bottom: 16px;
  }
  .header-uploaded-image {
    width: 100%;
    height: 200px;
    margin-bottom: 16px;
  }
  .footer-message {
    color: rgb(102, 102, 102);
    font-size: 12px;
    line-height: 14px;
    display: flex;
    -webkit-box-pack: justify;
    justify-content: space-between;
    margin-top: 1rem;
    align-items: flex-end;
  }
  .call-to-phone-image {
    background-image: url("https://app.wati.io/assets/icon_call.svg");
  }
  .visit-website-image {
    background-image: url("https://app.wati.io/assets/icon_web.svg");
  }
  .call-to-action {
    color: rgb(14, 113, 195);
    font-size: 12px;
    line-height: 14px;
    height: 34px;
    padding: 0px 0px 0px 20px;
    white-space: pre-wrap;
    background-repeat: no-repeat;
    background-size: 13px;
    flex-shrink: 0;
    opacity: 0.8;
    background-position: 0px 50%;
    display: flex;
    -webkit-box-align: center;
    align-items: center;
  }
  .outer-call-to-action {
    border-top: 1px solid rgb(232, 234, 242);
    margin-top: 14px;
    display: flex;
    flex-direction: column;
    -webkit-box-align: center;
    align-items: center;
    -webkit-box-pack: center;
    justify-content: center;
  }
`;
export {
  RemoveCloseButton,
  QuickReply,
  PreviewMessage,
}


// WEBPACK FOOTER //
// src/modules/screens/settings/WhatsappTemplate/styles.js